import { useQuery } from "@tanstack/react-query"
import { queries } from "../../queries"
import { useUser } from "../useUser"

export const useActivityPreferencesQuery = () => {
  const { user_uuid } = useUser()
  return useQuery(queries.activities.preferencesByUser(user_uuid))
}
